// User-related translations
const usersTranslations = {
    user_information: {
        th: "ข้อมูลผู้ใช้",
        en: "User Information",
        ja: "ユーザー情報",
    },
    user_information_description: {
        th: "ข้อมูลรายละเอียดเกี่ยวกับผู้ใช้",
        en: "Detailed information about the user",
        ja: "ユーザーに関する詳細情報",
    },
    unknown: {
        th: "ไม่ระบุ",
        en: "Unknown",
        ja: "不明",
    },
    posted_by: {
        th: "ผู้โพสต์:",
        en: "Posted by:",
        ja: "投稿者:",
    },
    date: {
        th: "วันที่:",
        en: "Date:",
        ja: "日付:",
    },
    // User roles
    role_admin: {
        th: "แอดมิน",
        en: "Admin",
        ja: "管理者",
    },
    role_editor: {
        th: "บรรณาธิการ",
        en: "Editor",
        ja: "編集者",
    },
    role_moderator: {
        th: "ผู้ดูแล",
        en: "Moderator",
        ja: "モデレータ",
    },
    role_expert: {
        th: "ผู้เชี่ยวชาญ",
        en: "Expert",
        ja: "専門家",
    },
    role_user: {
        th: "ผู้ใช้",
        en: "User",
        ja: "ユーザー",
    },
    role_guest: {
        th: "ผู้เยี่ยมชม",
        en: "Guest",
        ja: "ゲスト",
    },
    // Age group
    age_unit: {
        th: "ปี",
        en: "years",
        ja: "歳",
    },
    // Gender
    male: {
        th: "ชาย",
        en: "Male",
        ja: "男性",
    },
    female: {
        th: "หญิง",
        en: "Female",
        ja: "女性",
    },
    gender_male: {
        th: "ชาย",
        en: "Male",
        ja: "男性",
    },
    gender_female: {
        th: "หญิง",
        en: "Female",
        ja: "女性",
    },
    gender_other: {
        th: "อื่นๆ",
        en: "Other",
        ja: "その他",
    },
    gender_prefer_not_to_say: {
        th: "ไม่ระบุ",
        en: "Prefer not to say",
        ja: "無回答",
    },
    author: {
        th: "ผู้โพสต์",
        en: "Author",
        ja: "投稿者",
    },
    "discover-users": {
        th: "ค้นพบรีวิวเวอร์และสมาชิกในชุมชนความงามของเรา",
        en: "Discover beauty reviewers and members in our community",
        ja: "美容レビュアーとコミュニティメンバーを見つける",
    },
    users_admin_title: {
        th: "ผู้ใช้",
        en: "Users",
        ja: "ユーザー",
    },
    users_admin_description: {
        th: "ตรวจสอบและแก้ไขข้อมูลผู้ใช้สำหรับผู้ดูแลระบบ",
        en: "Review and edit user records for administrators.",
        ja: "管理者向けのユーザー一覧と編集画面です。",
    },
    users_admin_search_placeholder: {
        th: "ค้นหาชื่อเล่น ชื่อ หรืออีเมล",
        en: "Search nickname, name, or email",
        ja: "ニックネーム、氏名、メールで検索",
    },
    users_admin_all_roles: {
        th: "ทุกสิทธิ์",
        en: "All roles",
        ja: "すべての権限",
    },
    users_admin_all_statuses: {
        th: "ทุกสถานะ",
        en: "All statuses",
        ja: "すべての状態",
    },
    users_admin_include_dummy: {
        th: "รวมผู้ใช้ dummy",
        en: "Include dummy users",
        ja: "ダミーユーザーを含める",
    },
    users_admin_name: {
        th: "ผู้ใช้",
        en: "User",
        ja: "ユーザー",
    },
    users_admin_name_not_registered: {
        th: "ยังไม่ได้ระบุชื่อ",
        en: "Name not provided",
        ja: "名前未登録",
    },
    users_admin_email: {
        th: "อีเมล",
        en: "Email",
        ja: "メール",
    },
    users_admin_role: {
        th: "สิทธิ์",
        en: "Role",
        ja: "権限",
    },
    users_admin_status_label: {
        th: "สถานะ",
        en: "Status",
        ja: "状態",
    },
    users_admin_note: {
        th: "บันทึกผู้ดูแล",
        en: "Admin note",
        ja: "管理メモ",
    },
    users_admin_note_placeholder: {
        th: "บันทึกสำหรับผู้ดูแล (admin/editor เท่านั้น)",
        en: "Note for admins (admin/editor only)",
        ja: "管理者向けメモ（admin/editor のみ編集可）",
    },
    users_admin_activity: {
        th: "สถิติ",
        en: "Activity",
        ja: "統計",
    },
    users_admin_dates: {
        th: "วันที่",
        en: "Dates",
        ja: "日時",
    },
    users_admin_actions: {
        th: "การทำงาน",
        en: "Actions",
        ja: "操作",
    },
    users_admin_points: {
        th: "คะแนน",
        en: "Points",
        ja: "ポイント",
    },
    users_admin_posts: {
        th: "โพสต์",
        en: "Posts",
        ja: "投稿数",
    },
    users_admin_followers: {
        th: "ผู้ติดตาม",
        en: "Followers",
        ja: "フォロワー",
    },
    users_admin_updated: {
        th: "อัปเดต",
        en: "Updated",
        ja: "更新",
    },
    users_admin_last_login: {
        th: "เข้าสู่ระบบล่าสุด",
        en: "Last login",
        ja: "最終ログイン",
    },
    users_admin_total: {
        th: "ผู้ใช้ทั้งหมด {{count}} คน",
        en: "{{count}} users",
        ja: "{{count}} 人のユーザー",
    },
    users_admin_loaded: {
        th: "โหลดผู้ใช้แล้ว {{count}} คน",
        en: "Loaded {{count}} users",
        ja: "{{count}} 件のユーザーを読み込みました",
    },
    users_admin_empty: {
        th: "ไม่พบผู้ใช้ตามเงื่อนไข",
        en: "No users matched the current filters.",
        ja: "条件に一致するユーザーがありません。",
    },
    users_admin_edit: {
        th: "แก้ไข",
        en: "Edit",
        ja: "編集",
    },
    users_admin_create_success: {
        th: "สร้างผู้ใช้แล้ว",
        en: "User account created.",
        ja: "ユーザーを作成しました。",
    },
    users_admin_email_required: {
        th: "กรุณากรอกอีเมล",
        en: "Email is required",
        ja: "メールアドレスを入力してください",
    },
    users_admin_nickname_required: {
        th: "กรุณากรอกชื่อเล่น",
        en: "Nickname is required",
        ja: "ニックネームを入力してください",
    },
    users_admin_create_failed: {
        th: "ไม่สามารถสร้างผู้ใช้ได้",
        en: "Failed to create user account.",
        ja: "ユーザー作成に失敗しました。",
    },
    users_admin_create_password_ready: {
        th: "สร้างบัญชีแล้ว รหัสผ่านชั่วคราว:",
        en: "Account created. Temporary password:",
        ja: "アカウントを作成しました。仮パスワード:",
    },
    users_admin_login_history: {
        th: "ประวัติการเข้าสู่ระบบ",
        en: "Login history",
        ja: "ログイン履歴",
    },
    no_posts: {
        th: "ยังไม่มีโพสต์",
        en: "No posts",
        ja: "投稿がありません",
    },
    no_basic_info: {
        th: "ไม่มีข้อมูล",
        en: "No basic information",
        ja: "基本情報がありません",
    },
    users_admin_login_history_title: {
        th: "ประวัติการเข้าสู่ระบบ: {{name}}",
        en: "Login history: {{name}}",
        ja: "ログイン履歴: {{name}}",
    },
    users_admin_login_history_loading: {
        th: "กำลังโหลดประวัติการเข้าสู่ระบบ...",
        en: "Loading login history...",
        ja: "ログイン履歴を読み込み中...",
    },
    users_admin_login_history_empty: {
        th: "ยังไม่มีประวัติการเข้าสู่ระบบ",
        en: "No login history found.",
        ja: "ログイン履歴がありません。",
    },
    users_admin_login_history_load_failed: {
        th: "ไม่สามารถโหลดประวัติการเข้าสู่ระบบได้",
        en: "Failed to load login history.",
        ja: "ログイン履歴の取得に失敗しました。",
    },
    users_admin_login_history_at: {
        th: "วันที่",
        en: "Date",
        ja: "日時",
    },
    users_admin_login_history_result: {
        th: "ผลลัพธ์",
        en: "Result",
        ja: "結果",
    },
    users_admin_login_history_method: {
        th: "วิธีการ",
        en: "Method",
        ja: "方法",
    },
    users_admin_login_history_device: {
        th: "อุปกรณ์",
        en: "Device",
        ja: "デバイス",
    },
    users_admin_login_history_ip: {
        th: "IP",
        en: "IP",
        ja: "IP",
    },
    ip_geolocation_title: {
        th: "ตำแหน่งที่ตั้ง IP",
        en: "IP Geolocation",
        ja: "IP位置情報",
    },
    ip_geolocation_country: {
        th: "ประเทศ",
        en: "Country",
        ja: "国",
    },
    ip_geolocation_region: {
        th: "ภูมิภาค",
        en: "Region",
        ja: "地域",
    },
    ip_geolocation_city: {
        th: "เมือง",
        en: "City",
        ja: "市区町村",
    },
    ip_geolocation_org: {
        th: "ผู้ให้บริการ",
        en: "ISP / Org",
        ja: "プロバイダ",
    },
    ip_geolocation_loading: {
        th: "กำลังโหลด...",
        en: "Loading...",
        ja: "読み込み中...",
    },
    ip_geolocation_unavailable: {
        th: "ไม่สามารถดึงข้อมูลตำแหน่ง IP ได้",
        en: "IP geolocation unavailable",
        ja: "IP位置情報を取得できませんでした",
    },
    users_admin_login_history_reason: {
        th: "เหตุผล",
        en: "Reason",
        ja: "理由",
    },
    users_admin_login_history_success: {
        th: "สำเร็จ",
        en: "Success",
        ja: "成功",
    },
    users_admin_login_history_failed: {
        th: "ล้มเหลว",
        en: "Failed",
        ja: "失敗",
    },
    users_admin_login_history_reason_inactive_user: {
        th: "ผู้ใช้ถูกปิดใช้งาน",
        en: "Inactive user",
        ja: "無効ユーザー",
    },
    users_admin_login_history_reason_invalid_credentials: {
        th: "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
        en: "Invalid credentials",
        ja: "認証情報が正しくありません",
    },
    status_active: {
        th: "ใช้งาน",
        en: "Active",
        ja: "有効",
    },
    status_inactive: {
        th: "ไม่ใช้งาน",
        en: "Inactive",
        ja: "無効",
    },
    status_dummy: {
        th: "dummy",
        en: "dummy",
        ja: "ダミー",
    },
    status_migrated: {
        th: "ย้ายข้อมูล",
        en: "Migrated",
        ja: "移行",
    },
    // User profile page
    posts: {
        th: "โพสต์",
        en: "Posts",
        ja: "投稿",
    },
    followers: {
        th: "ผู้ติดตาม",
        en: "Followers",
        ja: "フォロワー",
    },
    followings: {
        th: "กำลังติดตาม",
        en: "Followings",
        ja: "フォロー中",
    },
    favorites: {
        th: "รายการโปรด",
        en: "Favorites",
        ja: "お気に入り",
    },

    // Recommend modal (ISS-04-034)
    user_recommend_rank_title: {
        th: "อันดับแนะนำ",
        en: "Recommend rank",
        ja: "おすすめ順位",
    },
    user_recommend_close: {
        th: "ปิด",
        en: "Close",
        ja: "閉じる",
    },
    user_recommend_tooltip: {
        th: "ผู้ใช้แนะนำ",
        en: "Recommended user",
        ja: "おすすめユーザ",
    },
    user_recommend_error_load: {
        th: "โหลดข้อมูลแนะนำไม่สำเร็จ",
        en: "Failed to load recommend info",
        ja: "おすすめ情報の取得に失敗しました",
    },
    user_recommend_error_update: {
        th: "อัปเดตอันดับแนะนำไม่สำเร็จ",
        en: "Failed to update recommend rank",
        ja: "おすすめ順位の更新に失敗しました",
    },
    user_recommend_error_unset: {
        th: "ยกเลิกการแนะนำไม่สำเร็จ",
        en: "Failed to unset recommend",
        ja: "おすすめの解除に失敗しました",
    },
    favorite_products: {
        th: "สินค้าที่ชื่นชอบ",
        en: "Favorite Products",
        ja: "お気に入り商品",
    },
    no_followers: {
        th: "ยังไม่มีผู้ติดตาม",
        en: "No followers yet",
        ja: "まだフォロワーがいません",
    },
    no_following: {
        th: "ยังไม่ได้ติดตามใคร",
        en: "Not following anyone yet",
        ja: "まだ誰もフォローしていません",
    },
    no_favorites: {
        th: "ยังไม่มีสินค้าโปรด",
        en: "No favorites yet",
        ja: "お気に入りはまだありません",
    },
    points: {
        th: "คะแนน",
        en: "Points",
        ja: "ポイント",
    },
    points_current_prefix: {
        th: "คะแนนปัจจุบันของคุณ",
        en: "Your current points",
        ja: "現在のポイント",
    },
    basic_info: {
        th: "ข้อมูลพื้นฐาน",
        en: "Basic Information",
        ja: "基本情報",
    },
    personal_information: {
        th: "ข้อมูลส่วนตัว",
        en: "Personal Information",
        ja: "個人情報",
    },
    activity_information: {
        th: "ข้อมูลการใช้งาน",
        en: "Activity Information",
        ja: "利用情報",
    },
    no_activity_info: {
        th: "ไม่มีข้อมูลการใช้งาน",
        en: "No activity information",
        ja: "利用情報はありません",
    },
    daily_missions_navbar: {
        th: "ภารกิจประจำวัน",
        en: "Daily Missions",
        ja: "ﾃﾞｲﾘｰﾐｯｼｮﾝ",
    },
    daily_missions: {
        th: "ภารกิจประจำวัน",
        en: "Daily Missions",
        ja: "デイリーミッション",
    },
    profile_preferences: {
        th: "ข้อมูลโปรไฟล์เพิ่มเติม",
        en: "Profile Preferences",
        ja: "プロフィール追加情報",
    },
    skin_type: {
        th: "สภาพผิว",
        en: "Skin Type",
        ja: "肌タイプ",
    },
    skinType: {
        th: "สภาพผิว",
        en: "Skin Type",
        ja: "肌タイプ",
    },
    skin_concerns: {
        th: "ปัญหาผิว",
        en: "Skin Concerns",
        ja: "肌悩み",
    },
    skinConcerns: {
        th: "ปัญหาผิว",
        en: "Skin Concerns",
        ja: "肌悩み",
    },
    skin_concerns_placeholder: {
        th: "เลือกปัญหาผิว...",
        en: "Select concerns...",
        ja: "肌悩みを選択...",
    },
    skin_concerns_hint: {
        th: "พิมพ์เพื่อเพิ่มรายการเองได้",
        en: "You can type to add custom items.",
        ja: "入力してカスタム項目を追加できます。",
    },
    skin_type_normal: {
        th: "ผิวธรรมดา",
        en: "Normal",
        ja: "普通肌",
    },
    skin_type_oily: {
        th: "ผิวมัน",
        en: "Oily",
        ja: "脂性肌",
    },
    skin_type_dry: {
        th: "ผิวแห้ง",
        en: "Dry",
        ja: "乾燥肌",
    },
    skin_type_combination: {
        th: "ผิวผสม",
        en: "Combination",
        ja: "混合肌",
    },
    skin_type_delicate: {
        th: "ผิวบอบบาง",
        en: "Delicate",
        ja: "デリケート肌",
    },
    skin_type_sensitive: {
        th: "ผิวแพ้ง่าย",
        en: "Sensitive",
        ja: "敏感肌",
    },
    skin_type_dehydrated_oily: {
        th: "ผิวขาดน้ำแต่มีความมัน",
        en: "Dehydrated Oily",
        ja: "インナードライ（脂性）",
    },
    skin_type_not_sure: {
        th: "ไม่แน่ใจ",
        en: "Not sure",
        ja: "わからない",
    },
    skin_concern_acne: {
        th: "สิว",
        en: "Acne",
        ja: "ニキビ",
    },
    skin_concern_pores: {
        th: "รูขุมขน",
        en: "Pores",
        ja: "毛穴",
    },
    skin_concern_blackheads: {
        th: "สิวหัวดำ",
        en: "Blackheads",
        ja: "黒ずみ",
    },
    skin_concern_whiteheads: {
        th: "สิวหัวขาว",
        en: "Whiteheads",
        ja: "白ニキビ",
    },
    skin_concern_dark_spots: {
        th: "จุดด่างดำ",
        en: "Dark spots",
        ja: "シミ",
    },
    skin_concern_redness: {
        th: "รอยแดง",
        en: "Redness",
        ja: "赤み",
    },
    skin_concern_wrinkles: {
        th: "ริ้วรอย",
        en: "Wrinkles",
        ja: "シワ",
    },
    skin_concern_dullness: {
        th: "ความหมองคล้ำ",
        en: "Dullness",
        ja: "くすみ",
    },
    skin_concern_oiliness: {
        th: "ความมันส่วนเกิน",
        en: "Oiliness",
        ja: "皮脂・テカリ",
    },
    skin_concern_irritation: {
        th: "การระคายเคือง",
        en: "Irritation",
        ja: "刺激・ヒリつき",
    },
    skin_tone: {
        th: "โทนสีผิว",
        en: "Skin Tone",
        ja: "肌トーン",
    },
    skin_tone_very_fair: {
        th: "ขาวมาก",
        en: "Very Fair",
        ja: "とても明るい",
    },
    skin_tone_fair: {
        th: "ขาว",
        en: "Fair",
        ja: "明るい",
    },
    skin_tone_medium: {
        th: "ปานกลาง",
        en: "Medium",
        ja: "標準",
    },
    skin_tone_tan: {
        th: "สองสี",
        en: "Tan",
        ja: "やや濃い",
    },
    skin_tone_deep: {
        th: "เข้ม",
        en: "Deep",
        ja: "濃い",
    },
    skin_tone_not_sure: {
        th: "ไม่แน่ใจ",
        en: "Not sure",
        ja: "わからない",
    },
    hair_type: {
        th: "ประเภทเส้นผม",
        en: "Hair Type",
        ja: "髪質",
    },
    hair_type_straight_coarse: {
        th: "ผมตรง (เส้นหนา)",
        en: "Straight (Coarse)",
        ja: "直毛（太め）",
    },
    hair_type_straight_soft: {
        th: "ผมตรง (เส้นนุ่ม)",
        en: "Straight (Soft)",
        ja: "直毛（やわらかい）",
    },
    hair_type_wavy_coarse: {
        th: "ผมหยักศก (เส้นหนา)",
        en: "Wavy (Coarse)",
        ja: "くせ毛（太め）",
    },
    hair_type_wavy_soft: {
        th: "ผมหยักศก (เส้นนุ่ม)",
        en: "Wavy (Soft)",
        ja: "くせ毛（やわらかい）",
    },
    hair_type_normal_hair: {
        th: "ผมปกติ",
        en: "Normal",
        ja: "普通",
    },
    hair_type_not_sure: {
        th: "ไม่แน่ใจ",
        en: "Not sure",
        ja: "わからない",
    },
    hair_scalp_concerns: {
        th: "ปัญหาเส้นผมและหนังศีรษะ",
        en: "Hair & Scalp Concerns",
        ja: "髪・頭皮の悩み",
    },
    hair_scalp_concerns_placeholder: {
        th: "เลือกปัญหาเส้นผม/หนังศีรษะ...",
        en: "Select concerns...",
        ja: "悩みを選択...",
    },
    hair_scalp_concern_hair_loss: {
        th: "ผมร่วง",
        en: "Hair loss",
        ja: "抜け毛",
    },
    hair_scalp_concern_damaged_hair: {
        th: "ผมเสีย",
        en: "Damaged hair",
        ja: "ダメージヘア",
    },
    hair_scalp_concern_oily_scalp: {
        th: "หนังศีรษะมัน",
        en: "Oily scalp",
        ja: "頭皮のベタつき",
    },
    hair_scalp_concern_scalp_problems: {
        th: "ปัญหาหนังศีรษะ",
        en: "Scalp problems",
        ja: "頭皮トラブル",
    },
    hair_scalp_concern_itchy_scalp_dandruff: {
        th: "คันหนังศีรษะ / รังแค",
        en: "Itchy scalp / dandruff",
        ja: "かゆみ・フケ",
    },
    hair_scalp_concern_no_concerns: {
        th: "ไม่มีปัญหา",
        en: "No concerns",
        ja: "悩みなし",
    },
    beauty_wellness_interests: {
        th: "ความสนใจด้านความงามและสุขภาพ",
        en: "Beauty & Wellness Interests",
        ja: "美容・ウェルネス関心",
    },
    beauty_wellness_interests_placeholder: {
        th: "เลือกความสนใจ...",
        en: "Select interests...",
        ja: "関心を選択...",
    },
    beauty_interest_sleep_stress: {
        th: "การนอน / ความเครียด",
        en: "Sleep / Stress",
        ja: "睡眠・ストレス",
    },
    beauty_interest_immunity: {
        th: "ภูมิคุ้มกัน",
        en: "Immunity",
        ja: "免疫",
    },
    beauty_interest_gut_health: {
        th: "สุขภาพลำไส้",
        en: "Gut health",
        ja: "腸内環境",
    },
    beauty_interest_skincare: {
        th: "การดูแลผิว",
        en: "Skincare",
        ja: "スキンケア",
    },
    beauty_interest_weight_management: {
        th: "การควบคุมน้ำหนัก",
        en: "Weight management",
        ja: "体重管理",
    },
    beauty_interest_none: {
        th: "ไม่มี",
        en: "None",
        ja: "なし",
    },
    lifestyle_environment: {
        th: "ไลฟ์สไตล์และสภาพแวดล้อม",
        en: "Lifestyle Environment",
        ja: "生活環境",
    },
    lifestyle_environment_placeholder: {
        th: "เลือกไลฟ์สไตล์...",
        en: "Select lifestyle...",
        ja: "生活環境を選択...",
    },
    lifestyle_environment_frequent_sun_exposure: {
        th: "โดนแดดบ่อย",
        en: "Frequent sun exposure",
        ja: "日光を浴びる機会が多い",
    },
    lifestyle_environment_regular_air_conditioned_environment: {
        th: "อยู่ในห้องแอร์เป็นประจำ",
        en: "Regular air-conditioned environment",
        ja: "空調環境にいることが多い",
    },
    lifestyle_environment_sweat_easily: {
        th: "เหงื่อออกง่าย",
        en: "Sweat easily",
        ja: "汗をかきやすい",
    },
    makeup_frequency: {
        th: "ความถี่ในการแต่งหน้า",
        en: "Makeup Frequency",
        ja: "メイク頻度",
    },
    makeup_frequency_every_day: {
        th: "ทุกวัน",
        en: "Every day",
        ja: "毎日",
    },
    makeup_frequency_occasionally: {
        th: "เป็นครั้งคราว",
        en: "Occasionally",
        ja: "ときどき",
    },
    makeup_frequency_rarely: {
        th: "แทบไม่แต่ง",
        en: "Rarely",
        ja: "ほとんどしない",
    },
    preferred_price_range: {
        th: "ช่วงราคาที่ต้องการ",
        en: "Preferred Price Range",
        ja: "希望価格帯",
    },
    preferred_price_range_thb_0_100: {
        th: "0-100 บาท",
        en: "THB 0-100",
        ja: "0-100バーツ",
    },
    preferred_price_range_thb_101_300: {
        th: "101-300 บาท",
        en: "THB 101-300",
        ja: "101-300バーツ",
    },
    preferred_price_range_thb_301_700: {
        th: "301-700 บาท",
        en: "THB 301-700",
        ja: "301-700バーツ",
    },
    preferred_price_range_thb_701_1500: {
        th: "701-1,500 บาท",
        en: "THB 701-1,500",
        ja: "701-1,500バーツ",
    },
    preferred_price_range_thb_1501_plus: {
        th: "1,501 บาทขึ้นไป",
        en: "THB 1,501+",
        ja: "1,501バーツ以上",
    },
    social_website: {
        th: "เว็บไซต์",
        en: "Website",
        ja: "Webサイト",
    },
    sns_info: {
        th: "ข้อมูล SNS",
        en: "SNS Information",
        ja: "SNS情報",
    },
    sns_required_hint: {
        th: "Instagram หรือ TikTok อย่างน้อยหนึ่งอัน จำเป็นต้องกรอก",
        en: "At least one of Instagram or TikTok is required",
        ja: "InstagramまたはTikTokのいずれかは必須です",
    },
    sns_username_placeholder: {
        th: "บัญชี หรือ URL",
        en: "Account or URL",
        ja: "アカウント名またはURL",
    },
    social_handle_checking: {
        th: "กำลังตรวจสอบ...",
        en: "Checking...",
        ja: "確認中...",
    },
    social_handle_check_valid: {
        th: "ตรวจสอบแล้ว",
        en: "Verified",
        ja: "確認できました",
    },
    social_handle_check_invalid: {
        th: "ไม่พบบัญชีนี้ หรือรูปแบบไม่ถูกต้อง",
        en: "Account not found or invalid format",
        ja: "アカウントが見つからないか、形式が正しくありません",
    },
    social_handle_save_blocked: {
        th: "กรุณาแก้ไขข้อมูล SNS ที่ไม่ถูกต้องก่อนบันทึก",
        en: "Please fix the invalid SNS field(s) before saving",
        ja: "保存する前に、無効なSNS欄を修正してください",
    },
    frequent_category_ids: {
        th: "หมวดหมู่ที่ใช้บ่อย",
        en: "Frequently Used Categories",
        ja: "よく使うカテゴリ",
    },
    frequent_brand_ids: {
        th: "แบรนด์ที่ใช้บ่อย",
        en: "Frequently Used Brands",
        ja: "よく使うブランド",
    },
    first_name: {
        th: "ชื่อจริง",
        en: "First Name",
        ja: "名",
    },
    last_name: {
        th: "นามสกุล",
        en: "Last Name",
        ja: "姓",
    },
    middle_name: {
        th: "ชื่อกลาง",
        en: "Middle Name",
        ja: "ミドルネーム",
    },
    name: {
        th: "ชื่อ",
        en: "Name",
        ja: "名前",
    },
    nickname: {
        th: "ชื่อเล่น",
        en: "Nickname",
        ja: "ニックネーム",
    },
    email: {
        th: "อีเมล",
        en: "Email",
        ja: "メール",
    },
    phone: {
        th: "เบอร์โทรศัพท์",
        en: "Phone",
        ja: "電話",
    },
    zip_code: {
        th: "รหัสไปรษณีย์",
        en: "Zip Code",
        ja: "郵便番号",
    },
    lookup_address: {
        th: "ค้นหาที่อยู่",
        en: "Lookup Address",
        ja: "住所検索",
    },
    birthday: {
        th: "วันเกิด",
        en: "Date of Birth",
        ja: "生年月日",
    },
    date_of_birth: {
        th: "วันเกิด",
        en: "Date of Birth",
        ja: "生年月日",
    },
    date_of_birth_with_age: {
        th: "วันเกิด ({{age}} ปี)",
        en: "Date of Birth ({{age}} yrs)",
        ja: "生年月日（{{age}}歳）",
    },
    age: {
        th: "อายุ",
        en: "Age",
        ja: "年齢",
    },
    age_value: {
        th: "{{age}} ปี",
        en: "{{age}} yrs",
        ja: "{{age}}歳",
    },
    age_paren: {
        th: " ({{age}} ปี)",
        en: " ({{age}} yrs)",
        ja: "（{{age}}歳）",
    },
    age_range: {
        th: "{{low}}-{{high}} ปี",
        en: "{{low}}-{{high}} yrs",
        ja: "{{low}}-{{high}}歳",
    },
    gender: {
        th: "เพศ",
        en: "Gender",
        ja: "性別",
    },
    address: {
        th: "ที่อยู่",
        en: "Address",
        ja: "住所",
    },
    address_shipping_hint: {
        th: "จำเป็นสำหรับการจัดส่งของที่ระลึก สินค้าส่งเสริมการขาย และของรางวัลจากแคมเปญต่างๆ",
        en: "Required for shipping novelty items, promotional goods, and campaign prizes.",
        ja: "ノベルティグッズ、販促品、プレゼント企画の送付に必要になります",
    },
    prefecture: {
        th: "จังหวัด",
        en: "Prefecture",
        ja: "都道府県",
    },
    prefecture_bangkok: {
        th: "กรุงเทพมหานคร",
        en: "Bangkok",
        ja: "Bangkok",
    },
    prefecture_krabi: {
        th: "กระบี่",
        en: "Krabi",
        ja: "Krabi",
    },
    prefecture_kanchanaburi: {
        th: "กาญจนบุรี",
        en: "Kanchanaburi",
        ja: "Kanchanaburi",
    },
    prefecture_kalasin: {
        th: "กาฬสินธุ์",
        en: "Kalasin",
        ja: "Kalasin",
    },
    prefecture_kamphaeng_phet: {
        th: "กำแพงเพชร",
        en: "Kamphaeng Phet",
        ja: "Kamphaeng Phet",
    },
    prefecture_khon_kaen: {
        th: "ขอนแก่น",
        en: "Khon Kaen",
        ja: "Khon Kaen",
    },
    prefecture_chanthaburi: {
        th: "จันทบุรี",
        en: "Chanthaburi",
        ja: "Chanthaburi",
    },
    prefecture_chachoengsao: {
        th: "ฉะเชิงเทรา",
        en: "Chachoengsao",
        ja: "Chachoengsao",
    },
    prefecture_chon_buri: {
        th: "ชลบุรี",
        en: "Chon Buri",
        ja: "Chon Buri",
    },
    prefecture_chai_nat: {
        th: "ชัยนาท",
        en: "Chai Nat",
        ja: "Chai Nat",
    },
    prefecture_chaiyaphum: {
        th: "ชัยภูมิ",
        en: "Chaiyaphum",
        ja: "Chaiyaphum",
    },
    prefecture_chumphon: {
        th: "ชุมพร",
        en: "Chumphon",
        ja: "Chumphon",
    },
    prefecture_chiang_rai: {
        th: "เชียงราย",
        en: "Chiang Rai",
        ja: "Chiang Rai",
    },
    prefecture_chiang_mai: {
        th: "เชียงใหม่",
        en: "Chiang Mai",
        ja: "Chiang Mai",
    },
    prefecture_trang: {
        th: "ตรัง",
        en: "Trang",
        ja: "Trang",
    },
    prefecture_trat: {
        th: "ตราด",
        en: "Trat",
        ja: "Trat",
    },
    prefecture_tak: {
        th: "ตาก",
        en: "Tak",
        ja: "Tak",
    },
    prefecture_nakhon_nayok: {
        th: "นครนายก",
        en: "Nakhon Nayok",
        ja: "Nakhon Nayok",
    },
    prefecture_nakhon_pathom: {
        th: "นครปฐม",
        en: "Nakhon Pathom",
        ja: "Nakhon Pathom",
    },
    prefecture_nakhon_phanom: {
        th: "นครพนม",
        en: "Nakhon Phanom",
        ja: "Nakhon Phanom",
    },
    prefecture_nakhon_ratchasima: {
        th: "นครราชสีมา",
        en: "Nakhon Ratchasima",
        ja: "Nakhon Ratchasima",
    },
    prefecture_nakhon_si_thammarat: {
        th: "นครศรีธรรมราช",
        en: "Nakhon Si Thammarat",
        ja: "Nakhon Si Thammarat",
    },
    prefecture_nonthaburi: {
        th: "นนทบุรี",
        en: "Nonthaburi",
        ja: "Nonthaburi",
    },
    prefecture_narathiwat: {
        th: "นราธิวาส",
        en: "Narathiwat",
        ja: "Narathiwat",
    },
    prefecture_nan: {
        th: "น่าน",
        en: "Nan",
        ja: "Nan",
    },
    prefecture_bueng_kan: {
        th: "บึงกาฬ",
        en: "Bueng Kan",
        ja: "Bueng Kan",
    },
    prefecture_buri_ram: {
        th: "บุรีรัมย์",
        en: "Buri Ram",
        ja: "Buri Ram",
    },
    prefecture_pathum_thani: {
        th: "ปทุมธานี",
        en: "Pathum Thani",
        ja: "Pathum Thani",
    },
    prefecture_prachuap_khiri_khan: {
        th: "ประจวบคีรีขันธ์",
        en: "Prachuap Khiri Khan",
        ja: "Prachuap Khiri Khan",
    },
    prefecture_prachin_buri: {
        th: "ปราจีนบุรี",
        en: "Prachin Buri",
        ja: "Prachin Buri",
    },
    prefecture_pattani: {
        th: "ปัตตานี",
        en: "Pattani",
        ja: "Pattani",
    },
    prefecture_phra_nakhon_si_ayutthaya: {
        th: "พระนครศรีอยุธยา",
        en: "Phra Nakhon Si Ayutthaya",
        ja: "Phra Nakhon Si Ayutthaya",
    },
    prefecture_phang_nga: {
        th: "พังงา",
        en: "Phang Nga",
        ja: "Phang Nga",
    },
    prefecture_phatthalung: {
        th: "พัทลุง",
        en: "Phatthalung",
        ja: "Phatthalung",
    },
    prefecture_phichit: {
        th: "พิจิตร",
        en: "Phichit",
        ja: "Phichit",
    },
    prefecture_phitsanulok: {
        th: "พิษณุโลก",
        en: "Phitsanulok",
        ja: "Phitsanulok",
    },
    prefecture_phetchaburi: {
        th: "เพชรบุรี",
        en: "Phetchaburi",
        ja: "Phetchaburi",
    },
    prefecture_phetchabun: {
        th: "เพชรบูรณ์",
        en: "Phetchabun",
        ja: "Phetchabun",
    },
    prefecture_phrae: {
        th: "แพร่",
        en: "Phrae",
        ja: "Phrae",
    },
    prefecture_phuket: {
        th: "ภูเก็ต",
        en: "Phuket",
        ja: "Phuket",
    },
    prefecture_maha_sarakham: {
        th: "มหาสารคาม",
        en: "Maha Sarakham",
        ja: "Maha Sarakham",
    },
    prefecture_mukdahan: {
        th: "มุกดาหาร",
        en: "Mukdahan",
        ja: "Mukdahan",
    },
    prefecture_mae_hong_son: {
        th: "แม่ฮ่องสอน",
        en: "Mae Hong Son",
        ja: "Mae Hong Son",
    },
    prefecture_yasothon: {
        th: "ยโสธร",
        en: "Yasothon",
        ja: "Yasothon",
    },
    prefecture_yala: {
        th: "ยะลา",
        en: "Yala",
        ja: "Yala",
    },
    prefecture_roi_et: {
        th: "ร้อยเอ็ด",
        en: "Roi Et",
        ja: "Roi Et",
    },
    prefecture_ranong: {
        th: "ระนอง",
        en: "Ranong",
        ja: "Ranong",
    },
    prefecture_rayong: {
        th: "ระยอง",
        en: "Rayong",
        ja: "Rayong",
    },
    prefecture_ratchaburi: {
        th: "ราชบุรี",
        en: "Ratchaburi",
        ja: "Ratchaburi",
    },
    prefecture_lop_buri: {
        th: "ลพบุรี",
        en: "Lop Buri",
        ja: "Lop Buri",
    },
    prefecture_lampang: {
        th: "ลำปาง",
        en: "Lampang",
        ja: "Lampang",
    },
    prefecture_lamphun: {
        th: "ลำพูน",
        en: "Lamphun",
        ja: "Lamphun",
    },
    prefecture_loei: {
        th: "เลย",
        en: "Loei",
        ja: "Loei",
    },
    prefecture_si_sa_ket: {
        th: "ศรีสะเกษ",
        en: "Si Sa Ket",
        ja: "Si Sa Ket",
    },
    prefecture_sakon_nakhon: {
        th: "สกลนคร",
        en: "Sakon Nakhon",
        ja: "Sakon Nakhon",
    },
    prefecture_songkhla: {
        th: "สงขลา",
        en: "Songkhla",
        ja: "Songkhla",
    },
    prefecture_satun: {
        th: "สตูล",
        en: "Satun",
        ja: "Satun",
    },
    prefecture_samut_prakan: {
        th: "สมุทรปราการ",
        en: "Samut Prakan",
        ja: "Samut Prakan",
    },
    prefecture_samut_songkhram: {
        th: "สมุทรสงคราม",
        en: "Samut Songkhram",
        ja: "Samut Songkhram",
    },
    prefecture_samut_sakhon: {
        th: "สมุทรสาคร",
        en: "Samut Sakhon",
        ja: "Samut Sakhon",
    },
    prefecture_sa_kaeo: {
        th: "สระแก้ว",
        en: "Sa Kaeo",
        ja: "Sa Kaeo",
    },
    prefecture_saraburi: {
        th: "สระบุรี",
        en: "Saraburi",
        ja: "Saraburi",
    },
    prefecture_sing_buri: {
        th: "สิงห์บุรี",
        en: "Sing Buri",
        ja: "Sing Buri",
    },
    prefecture_sukhothai: {
        th: "สุโขทัย",
        en: "Sukhothai",
        ja: "Sukhothai",
    },
    prefecture_suphan_buri: {
        th: "สุพรรณบุรี",
        en: "Suphan Buri",
        ja: "Suphan Buri",
    },
    prefecture_surat_thani: {
        th: "สุราษฎร์ธานี",
        en: "Surat Thani",
        ja: "Surat Thani",
    },
    prefecture_surin: {
        th: "สุรินทร์",
        en: "Surin",
        ja: "Surin",
    },
    prefecture_nong_khai: {
        th: "หนองคาย",
        en: "Nong Khai",
        ja: "Nong Khai",
    },
    prefecture_nong_bua_lam_phu: {
        th: "หนองบัวลำภู",
        en: "Nong Bua Lam Phu",
        ja: "Nong Bua Lam Phu",
    },
    prefecture_ang_thong: {
        th: "อ่างทอง",
        en: "Ang Thong",
        ja: "Ang Thong",
    },
    prefecture_amnat_charoen: {
        th: "อำนาจเจริญ",
        en: "Amnat Charoen",
        ja: "Amnat Charoen",
    },
    prefecture_udon_thani: {
        th: "อุดรธานี",
        en: "Udon Thani",
        ja: "Udon Thani",
    },
    prefecture_uttaradit: {
        th: "อุตรดิตถ์",
        en: "Uttaradit",
        ja: "Uttaradit",
    },
    prefecture_uthai_thani: {
        th: "อุทัยธานี",
        en: "Uthai Thani",
        ja: "Uthai Thani",
    },
    prefecture_ubon_ratchathani: {
        th: "อุบลราชธานี",
        en: "Ubon Ratchathani",
        ja: "Ubon Ratchathani",
    },
    social_links: {
        th: "ลิงก์โซเชียลมีเดีย",
        en: "Social Links",
        ja: "SNSリンク",
    },
    instagram: {
        th: "Instagram",
        en: "Instagram",
        ja: "Instagram",
    },
    facebook: {
        th: "Facebook",
        en: "Facebook",
        ja: "Facebook",
    },
    x_twitter: {
        th: "X (Twitter)",
        en: "X (Twitter)",
        ja: "X (Twitter)",
    },
    tiktok: {
        th: "TikTok",
        en: "TikTok",
        ja: "TikTok",
    },
    youtube: {
        th: "YouTube",
        en: "YouTube",
        ja: "YouTube",
    },
    account_info: {
        th: "ข้อมูลบัญชี",
        en: "Account Information",
        ja: "アカウント情報",
    },
    joined: {
        th: "วันที่สมัคร",
        en: "Joined",
        ja: "登録日",
    },
    last_updated: {
        th: "อัปเดตล่าสุด",
        en: "Last Updated",
        ja: "最終更新",
    },
    last_login: {
        th: "ล็อกอินล่าสุด",
        en: "Last Login",
        ja: "最終ログイン",
    },
    instagram_connection: {
        th: "การเชื่อมต่อ Instagram",
        en: "Instagram Connection",
        ja: "Instagram連携",
    },
    instagram_connected: {
        th: "เชื่อมต่อแล้ว",
        en: "Connected",
        ja: "連携済み",
    },
    instagram_not_connected: {
        th: "ยังไม่ได้เชื่อมต่อ",
        en: "Not connected",
        ja: "未連携",
    },
    instagram_connection_updated: {
        th: "อัปเดตล่าสุด",
        en: "Updated",
        ja: "最終同期",
    },
    instagram_connection_connected: {
        th: "เชื่อมต่อบัญชี Instagram เรียบร้อยแล้ว",
        en: "Instagram account connected successfully.",
        ja: "Instagram アカウントを連携しました。",
    },
    instagram_connection_disconnected: {
        th: "ยกเลิกการเชื่อมต่อบัญชี Instagram แล้ว",
        en: "Instagram account disconnected.",
        ja: "Instagram アカウントの連携を解除しました。",
    },
    instagram_connection_failed: {
        th: "ไม่สามารถเชื่อมต่อบัญชี Instagram ได้",
        en: "Unable to connect Instagram account.",
        ja: "Instagram アカウントを連携できませんでした。",
    },
    instagram_connection_cancelled: {
        th: "ยกเลิกการเชื่อมต่อ Instagram แล้ว",
        en: "Instagram connection was cancelled.",
        ja: "Instagram 連携がキャンセルされました。",
    },
    tiktok_connection: {
        th: "การเชื่อมต่อ TikTok",
        en: "TikTok Connection",
        ja: "TikTok連携",
    },
    tiktok_connected: {
        th: "เชื่อมต่อแล้ว",
        en: "Connected",
        ja: "連携済み",
    },
    tiktok_not_connected: {
        th: "ยังไม่ได้เชื่อมต่อ",
        en: "Not connected",
        ja: "未連携",
    },
    tiktok_connection_updated: {
        th: "อัปเดตล่าสุด",
        en: "Updated",
        ja: "最終同期",
    },
    tiktok_connection_actions: {
        th: "การจัดการการเชื่อมต่อ",
        en: "Connection Actions",
        ja: "連携操作",
    },
    connect_instagram: {
        th: "เชื่อมต่อ Instagram",
        en: "Connect Instagram",
        ja: "Instagram を連携",
    },
    disconnect_instagram: {
        th: "ยกเลิก Instagram",
        en: "Disconnect Instagram",
        ja: "Instagram 連携を解除",
    },
    connect_tiktok: {
        th: "เชื่อมต่อ TikTok",
        en: "Connect TikTok",
        ja: "TikTok を連携",
    },
    reconnect_tiktok: {
        th: "เชื่อมต่อ TikTok ใหม่",
        en: "Reconnect TikTok",
        ja: "TikTok を再連携",
    },
    disconnect_tiktok: {
        th: "ยกเลิกการเชื่อมต่อ TikTok",
        en: "Disconnect TikTok",
        ja: "TikTok 連携を解除",
    },
    tiktok_connection_connected: {
        th: "เชื่อมต่อบัญชี TikTok เรียบร้อยแล้ว",
        en: "TikTok account connected successfully.",
        ja: "TikTok アカウントを連携しました。",
    },
    tiktok_connection_disconnected: {
        th: "ยกเลิกการเชื่อมต่อบัญชี TikTok แล้ว",
        en: "TikTok account disconnected.",
        ja: "TikTok アカウントの連携を解除しました。",
    },
    tiktok_connection_failed: {
        th: "ไม่สามารถเชื่อมต่อบัญชี TikTok ได้",
        en: "Unable to connect TikTok account.",
        ja: "TikTok アカウントを連携できませんでした。",
    },
    tiktok_connection_cancelled: {
        th: "ยกเลิกการเชื่อมต่อ TikTok แล้ว",
        en: "TikTok connection was cancelled.",
        ja: "TikTok 連携がキャンセルされました。",
    },
    // Avatar change modal
    change_avatar: {
        th: "เปลี่ยนรูปโปรไฟล์",
        en: "Change Avatar",
        ja: "プロフィール画像を変更",
    },
    avatar_requirements: {
        th: "รองรับ JPG, PNG, WEBP (สูงสุด 2MB)",
        en: "Supports JPG, PNG, WEBP (max 2MB)",
        ja: "JPG、PNG、WEBP対応 (最大2MB)",
    },
    cancel: {
        th: "ยกเลิก",
        en: "Cancel",
        ja: "キャンセル",
    },
    save: {
        th: "บันทึก",
        en: "Save",
        ja: "保存",
    },
    uploading: {
        th: "กำลังอัพโหลด...",
        en: "Uploading...",
        ja: "アップロード中...",
    },
    // Avatar upload error messages
    error_select_image_only: {
        th: "กรุณาเลือกไฟล์รูปภาพเท่านั้น...",
        en: "Please select an image file only...",
        ja: "画像ファイルのみを選択してください...",
    },
    error_file_too_large: {
        th: "ไฟล์มีขนาดใหญ่เกิน 10MB",
        en: "File size exceeds 10MB",
        ja: "ファイルサイズが10MBを超えています",
    },
    error_select_image_first: {
        th: "กรุณาเลือกรูปภาพก่อน...",
        en: "Please select an image first...",
        ja: "先に画像を選択してください...",
    },
    error_cannot_upload: {
        th: "ไม่สามารถอัพโหลดรูปภาพได้",
        en: "Cannot upload image",
        ja: "画像をアップロードできません",
    },
    error_upload_failed: {
        th: "เกิดข้อผิดพลาดในการอัพโหลด",
        en: "Upload failed",
        ja: "アップロードに失敗しました",
    },
    success_avatar_updated: {
        th: "อัพเดตรูปโปรไฟล์สำเร็จ",
        en: "Avatar updated successfully",
        ja: "プロフィール画像を更新しました",
    },
    btn_follow: {
        th: "ติดตาม",
        en: "Follow",
        ja: "フォロー",
    },
    btn_unfollow: {
        th: "เลิกติดตาม",
        en: "Unfollow",
        ja: "フォロー解除",
    },
    btn_followback: {
        th: "ติดตามกลับ",
        en: "Follow Back",
        ja: "フォローバック",
    },
};

export { usersTranslations };
